export const WELCOME_SCREEN = "WELCOME_SCREEN";
export const ILLUSTRATION_RADIO_BUTTONS = "ILLUSTRATION_RADIO_BUTTONS";
export const QUSETION_ANSWER = "QUSETION_ANSWER";
export const ILLUSTRATIONS_ANSWERS = "ILLUSTRATIONS_ANSWERS";
export const WORDS_RADIO_BUTTONS = "WORDS_RADIO_BUTTONS";
